<template lang="pug">
  v-data-table(
    :headers="allHeaders"
    :items="allItems"
    :options.sync="pagination"
    :footer-props="rowsPerPageItems"
    :server-items-length="itemsCount"
    @page-count="pageCount = $event"
    no-data-text="Нет записей"
    no-results-text="Ничего не найдено"
  )
    template(#top)
      v-toolbar(flat)
        v-toolbar-title(v-if="title") {{ title }}
        v-divider.mx-4(v-if="title" inset vertical)
        slot(name="filter" :refreshIndex="refreshIndex")
        v-spacer
        modal(:dialog.sync="formDialog" @confirm="save")
          template(#title)
            v-col
              h2 {{ id ? 'Изменить' : 'Добавить' }}
          template(#activator)
            v-btn(@click="addButton")
              v-icon add
          validation-observer(ref="observer")
            slot(name="form")
        modal(v-bind:dialog.sync="deleteDialog" @confirm="deleteItem")
          template(#title)
            v-col
              h2.text-center Хотите удалить?
          template(#save-button) Да
    template(v-for="field in fields" v-slot:[field]="{ item, value }")
      slot(:name="field" :item="item" :value="value")
        div {{ value === null || value === undefined ? '-' : value }}
    template(#item.actions="{ item }")
      slot(name="actions" :item="item")
        v-btn(@click="editButton(item)" icon)
          v-icon edit
        v-btn(@click="deleteButton(item)" icon)
          v-icon delete
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'Crud',
  components: {
    Modal,
  },
  props: {
    ownMethod: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    headers: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    filter: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    apiService: {
      required: false,
      type: Object,
      default: () => null,
    },
    items: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
  computed: {
    allHeaders() {
      const { headers } = this;
      headers.push({
        text: 'Действия',
        value: 'actions',
        align: 'right',
      });
      return headers;
    },
    title() {
      return this.$route.meta.title ? this.$route.meta.title : '';
    },
    fields() {
      const fields = [];
      this.headers.forEach((item) => {
        fields.push(`item.${item.value}`);
      });
      return fields;
    },
  },
  watch: {
    formDialog(val) {
      if (!val) {
        this.$refs.observer.reset();
      }
    },
    pagination: {
      handler() {
        if (this.apiService) {
          this.refreshIndex();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      id: undefined,
      allItems: [],
      formDialog: false,
      deleteDialog: false,
      itemsCount: null,
      rowsPerPageItems: {
        'items-per-page-options': [10, 20, 30, 40, 50],
      },
      pagination: {
        page: 1,
        pageCount: 0,
        itemsPerPage: 50,
      },
    };
  },
  created() {
  },
  methods: {
    save() {
      this.$refs.observer.handleSubmit(() => {
        this.$emit('save');
        if (!this.ownMethod) {
          if (this.id) {
            this.update();
          } else {
            this.create();
          }
        }
      });
    },
    addButton() {
      this.id = false;
      const newItem = {};
      Object.entries(this.item).forEach(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
          newItem[key] = {};
        } else {
          newItem[key] = null;
        }
      });
      this.$emit('update:item', newItem);
      this.formDialog = true;
    },
    editButton(update) {
      this.id = update.id;
      Object.entries(this.item).forEach(([key, value]) => {
        if (typeof value === 'object' && value !== null && (typeof update[key] !== 'object' || update[key] === null)) {
          update[key] = {};
        }
      });
      this.$emit('update:item', update);
      this.formDialog = true;
    },
    deleteButton(item) {
      this.id = item.id;
      this.deleteDialog = true;
    },
    create() {
      const createItem = {};
      Object.entries(this.item).forEach(([key, value]) => {
        if (value !== null && typeof value === 'object') {
          createItem[key] = value.id;
        } else {
          createItem[key] = value;
        }
      });
      this.apiService.create(createItem).then((response) => {
        response.onSuccess((item) => {
          this.formDialog = false;
          const newItems = this.allItems;
          newItems.push(item);
          this.allItems = newItems;
          this.itemsCount = this.allItems.count;
          this.pagination.pageCount = this.allItems.count;
          this.$emit('update:items', newItems);
          this.$emit('created');
        });
        response.onValidationFailure((errors) => {
          this.$refs.observer.setErrors(errors);
        });
        response.onError((message) => {
          this.$toasted.error(message, { duration: 4000 });
        });
      });
    },
    update() {
      const updateItem = {};
      Object.entries(this.item).forEach(([key, value]) => {
        if (value !== null && typeof value === 'object') {
          updateItem[key] = value.id;
        } else {
          updateItem[key] = value;
        }
      });

      this.apiService.update(this.id, updateItem).then((response) => {
        response.onSuccess(() => {
          this.formDialog = false;
          const items = [];
          this.allItems.forEach((item, index) => {
            if (item.id === this.id) {
              items[index] = this.item;
            } else {
              items[index] = item;
            }
          });

          this.allItems = items;
          this.$emit('update:items', items);
          this.$emit('updated');
        });
        response.onValidationFailure((errors) => {
          this.$refs.observer.setErrors(errors);
        });
        response.onError((message) => {
          this.$toasted.error(message, { duration: 4000 });
        });
      });
    },
    deleteItem() {
      this.apiService.delete(this.id).then((response) => {
        response.onSuccess(() => {
          const newItems = this.allItems.filter((item) => item.id !== this.id);

          this.allItems = newItems;
          this.itemsCount = this.allItems.count;
          this.$emit('update:items', newItems);
          this.$emit('deleted');
          this.deleteDialog = false;
        });
        response.onError((message) => {
          this.$toasted.error(message, { duration: 4000 });
        });
      });
    },
    refreshIndex() {
      setTimeout(() => {
        const processedFilter = {};
        Object.entries(this.filter).forEach(([key, value]) => {
          if (value) {
            processedFilter[`filter[${key}]`] = value;
          }
        });
        this.apiService.index(Object.assign(processedFilter, {
          'page': this.pagination.page,
          'per-page': this.pagination.itemsPerPage,
        }))
          .then((response) => {
            response.onSuccess((data) => {
              this.allItems = data.data;
              this.$emit('update:items', data.data);
              this.itemsCount = parseInt(data.count);
            });
          });
      }, 150);
    },
  },
};
</script>

<style scoped>

</style>
